// extracted by mini-css-extract-plugin
export var grid = "_2b-0";
export var span1 = "_2b-2";
export var span10 = "_2b-b";
export var span10L = "_2b-z";
export var span10M = "_2b-n";
export var span10Xl = "_2b-1b";
export var span11 = "_2b-c";
export var span11L = "_2b-10";
export var span11M = "_2b-o";
export var span11Xl = "_2b-1c";
export var span12 = "_2b-d";
export var span12L = "_2b-11";
export var span12M = "_2b-p";
export var span12Xl = "_2b-1d";
export var span1L = "_2b-q";
export var span1M = "_2b-e";
export var span1Xl = "_2b-12";
export var span2 = "_2b-3";
export var span2L = "_2b-r";
export var span2M = "_2b-f";
export var span2Xl = "_2b-13";
export var span3 = "_2b-4";
export var span3L = "_2b-s";
export var span3M = "_2b-g";
export var span3Xl = "_2b-14";
export var span4 = "_2b-5";
export var span4L = "_2b-t";
export var span4M = "_2b-h";
export var span4Xl = "_2b-15";
export var span5 = "_2b-6";
export var span5L = "_2b-u";
export var span5M = "_2b-i";
export var span5Xl = "_2b-16";
export var span6 = "_2b-7";
export var span6L = "_2b-v";
export var span6M = "_2b-j";
export var span6Xl = "_2b-17";
export var span7 = "_2b-8";
export var span7L = "_2b-w";
export var span7M = "_2b-k";
export var span7Xl = "_2b-18";
export var span8 = "_2b-9";
export var span8L = "_2b-x";
export var span8M = "_2b-l";
export var span8Xl = "_2b-19";
export var span9 = "_2b-a";
export var span9L = "_2b-y";
export var span9M = "_2b-m";
export var span9Xl = "_2b-1a";
export var stretch = "_2b-1";